import React, { useEffect, useState } from 'react'
import APISESSION from "../api/ApiSession.js";
import ProgressBarContainer from "../components/progressBar/progressBarContainer.js";
import SupportDocument from "./supportDocument.jsx";
import { getProjectId } from "../utils/project.js";
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
const apiSession = new APISESSION();
const BOM = (props) => {
 const [bomList, setBomList] = useState([]);
 const [dataTrafficList, setDataTrafficList] = useState([]);
 const [pvBessPowers, setPvBessPowers] = useState(null);
 const [loading, setLoading] = useState(true);
 const [showDetailsLience, setShowDetailsLience] = useState(-1);
 const [showDetailsController, setShowDetailsController] = useState(-1);
//  const [projectStatusData, setProjectStatusData] = useState(null);
 const [totalTags, setTotalTags] = useState(0);
 const [showSupportDocumentDialog, setShowSupportDocumentDialog] = useState(false);
 const [documentList, setDocumentList] = useState([]);
 const { projectId } = props?.match?.params
 useEffect(()=>{
    loadBOM();
    getProjectDetailStatus();
 },[]);
 const getProjectDetailStatus = () => {
    try {
    //   apiSession.getProjectStatus(projectId).then((response) => {
    //     if (response) {
    //       this.setState({ projectStatusData: response });
    //       // this.props.updateProjectType(
    //       //   response.projectType,
    //       //   response.projectName
    //       // );
    //       sessionStorage.setItem("pType", response.projectType);
    //     }
    //   });
      apiSession
        .listAllBOMDocuments(projectId, "bom")
        .then((response) =>
         setDocumentList(response.documentBlobInfo)
        );
    } catch (error) {
      console.log(error);
    }
  };

  const loadBOM = () => {
    apiSession
      .getBomList(projectId)
      .then((response) => {
        setLoading(true);
        if (response) {
          let bomListNew = Object.assign([], bomList);
          let dataTrafficListNew = Object.assign(
            [],
            dataTrafficList
          );
          bomListNew = response;
          dataTrafficListNew = response;
          setBomList(bomListNew.bom);
          setPvBessPowers(response?.pvBessPowers);
          setDataTrafficList(dataTrafficListNew.dataTraffic)
          dataTrafficListNew?.dataTraffic?.map((dataTraffic) =>
            
            setTotalTags(prev => prev + dataTraffic.quantityOfTags)
          );
          setLoading(false);
        }
      })
      .catch((error) => {
        if (error.response !== undefined) {
          //do nothing
          setLoading(false);
        }
      });
  }
 const showLicenseMore =(index)=> {
    setShowDetailsLience(index)
  }

  const showControllerMore =(index)=> {
    setShowDetailsController(index)
  }
  return (
    <>

      <div className="container-fluid h-100 container-margin">
        <se-loading loading={loading}></se-loading>
        <se-container option="centered" className="mt-2">
          <div className="container se-white-background pb-2">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 pt-1">
              <div className=" se-font-14px-bold se-life-green mb-2 mt-2">
                <div
                  className="flex-10 se-font-14px-bold se-life-green mb-2 mt-2"
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    justifyContent: "space-between",
                  }}
                >
                  <span> Microgrid Controller Bill of materials </span>
                  { documentList?.length > 0 &&
                    <a
                      href=""
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        setShowSupportDocumentDialog(true);
                      }}
                    >
                      Support Document
                    </a>
                  }
                </div>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered mb-0 se-font-14px">
                  <thead>
                    <tr>
                      <th>Commercial Reference</th>
                      <th>Description</th>
                      <th>Quantity</th>
                      {/* <th>Reference</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan="3">Controller</td>
                    </tr>
                    {bomList.map((bomData, index) =>
                      bomData.type === "controller" &&
                      bomData.partNumber !== "TCSESB083F23F0" ? (
                        <tr>
                          <td> {bomData.partNumber}</td>
                          <td> {bomData.description}</td>
                          <td> {bomData.quantity}</td>
                          {/* <td className="text-center"><se-link url={bomData.link}>Link</se-link></td> */}
                        </tr>
                      ) : (
                        ""
                      )
                    )}

                    {bomList.findIndex(
                      (bom) => bom.type === "license"
                    ) > -1 && (
                      <tr>
                        <td colspan="3">License</td>
                      </tr>
                    )}

                    {bomList.map((bomData, index) =>
                      bomData.type === "license" ? (
                        <tr>
                          <td> {bomData.partNumber}</td>
                          <td> {bomData.description}</td>
                          <td> {bomData.quantity}</td>
                        </tr>
                      ) : (
                        ""
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {!loading && dataTrafficList && (
              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 pt-1 mt-4 mb-5">
                <div className="se-font-14px-bold se-life-green mb-2 mt-2">
                  Data Traffic Calculation
                </div>
                <div className="table-responsive">
                  <table className="table table-bordered mb-0 se-font-14px">
                    <thead>
                      <tr className="text-center">
                        <th>Resource</th>
                        <th>Quantity of PM</th>
                        <th>Quantity of CB</th>
                        <th>Quantity of DEVICES</th>
                        {/* <th>Quantity of RESOURCES</th> */}
                        <th>Quantity of TAGS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataTrafficList.map(
                        (dataTraffic, index) => (
                          <tr className="text-center">
                            <td> {dataTraffic.resource}</td>
                            <td>
                              {" "}
                              {dataTraffic.resource === "MICROGRID" &&
                              dataTraffic.quantityOfPowerMeters === 0
                                ? "NA"
                                : dataTraffic.quantityOfPowerMeters === 0
                                ? "NA"
                                : dataTraffic.quantityOfPowerMeters}
                            </td>
                            <td>
                              {" "}
                              {dataTraffic.resource === "MICROGRID" &&
                              dataTraffic.quantityOfCircuitBreakers === 0
                                ? "NA"
                                : dataTraffic.quantityOfCircuitBreakers === 0
                                ? "NA"
                                : dataTraffic.quantityOfCircuitBreakers}
                            </td>
                            <td>
                              {" "}
                              {["MICROGRID", "UTILITY", "LOADS"].includes(
                                dataTraffic.resource
                              ) && dataTraffic.quantityOfDevices === 0
                                ? "NA"
                                : dataTraffic.quantityOfDevices}
                            </td>
                            {/* <td> { dataTraffic.resource === "MICROGRID" && dataTraffic.quantityOfResources === 0?"NA":dataTraffic.quantityOfResources}</td> */}
                            <td> {dataTraffic.quantityOfTags}</td>
                          </tr>
                        )
                      )}
                      <tr className="text-center">
                        <td className="bold">TOTAL</td>
                        <td>{""}</td>
                        <td>{""}</td>
                        <td>{""}</td>
                        {/* <td>{""}</td> */}
                        <td className="bold">{totalTags}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}
             {pvBessPowers && (
              <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 pt-1 mt-4 mb-5">
                <div className="se-font-14px-bold se-life-green mb-2 mt-2">
                  PV + BESS kW Calculation
                </div>
                <div className="table-responsive">
                  <table className="table table-bordered table-hover table-striped mb-0 se-font-14px" >
                    <thead>
                      <tr className="text-left" style={{backgroundColor:"#595c5f87"}}>
                        <th>Topic</th>
                        <th className='text-light'>kW</th>
                      </tr>
                    </thead>
                    <tbody>
                    <tr className="text-left">
                            <td > {"PV+BESS kW in base pack"}</td>
                            <td>{pvBessPowers["PV+BESS kW in base pack"]}</td>
                    </tr>
                    <tr className="text-left">
                            <td> {"Additional PV+BESS kW required"}</td>
                            <td>{pvBessPowers["Additional PV+BESS kW required"]}</td>
                    </tr>
                    <tr className="text-left">
                            <td> {"Additional PV+BESS kW selected"}</td>
                            <td style={{color: pvBessPowers["Additional PV+BESS kW selected"] < pvBessPowers["Additional PV+BESS kW required"]?"red":"black"}}>{pvBessPowers["Additional PV+BESS kW selected"]}</td>
                    </tr>
                    
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </se-container>
      </div>
      <SupportDocument
        onClose={() =>
             setShowSupportDocumentDialog(false)
            }
        showSupportDocumentDialog={showSupportDocumentDialog}
        documentList={documentList}
      />
    </>
  );
}
export default withRouter(BOM);
